function pickField(item, camel) {
  if (!item) return undefined;
  if (item[camel] != null) return item[camel];
  const snake = camel.replace(/[A-Z]/g, (c) => `_${c.toLowerCase()}`);
  return item[snake];
}

export function formatEngagementCount(n) {
  const x = Number(n) || 0;
  if (x >= 1_000_000) {
    return `${(x / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (x >= 1000) {
    return `${(x / 1000).toFixed(1).replace(/\.0$/, '')}k`;
  }
  return String(x);
}

export function catalogSubscriberTotal(item) {
  if (!item) return 0;
  return (
    (Number(pickField(item, 'librarySubscriberCount')) || 0)
    + (Number(pickField(item, 'learnSubscriberCount')) || 0)
  );
}

export function catalogReaderCount(item) {
  if (!item) return 0;
  const weekly = Number(pickField(item, 'activeReaderCount')) || 0;
  const total = Number(pickField(item, 'totalReaderCount')) || 0;
  return Math.max(weekly, total);
}

export function catalogQuestionCount(item) {
  return Number(pickField(item, 'questionCount')) || 0;
}

function normalizeRow(raw, publicByTitle) {
  const topic = raw?.topic || raw?.title;
  if (!topic) return null;
  const key = String(topic).trim().toLowerCase();
  const nb = publicByTitle.get(key);
  const row = {
    topic: String(topic).trim(),
    learnNotebookId: pickField(raw, 'learnNotebookId') ?? nb?.id ?? null,
    description: pickField(raw, 'description') ?? nb?.description ?? '',
    questionCount: catalogQuestionCount(raw),
    librarySubscriberCount: Number(pickField(raw, 'librarySubscriberCount')) || 0,
    learnSubscriberCount: Number(pickField(raw, 'learnSubscriberCount')) || 0,
    activeReaderCount: Number(pickField(raw, 'activeReaderCount')) || 0,
    totalReaderCount: Number(pickField(raw, 'totalReaderCount')) || 0,
  };
  if (nb) {
    row.learnNotebookId = row.learnNotebookId ?? nb.id;
    row.questionCount = Math.max(row.questionCount, Number(nb.questionCount) || 0);
    if (!row.description && nb.description) row.description = nb.description;
    if (nb.subscribedByViewer) row.learnSubscriberCount = Math.max(row.learnSubscriberCount, 1);
  }
  return row;
}

/** Normalize API catalogItems or build from legacy string catalog + public notebooks. */
export function normalizeCatalogItems(payload) {
  const publicList = [
    ...(Array.isArray(payload?.publicNotebooks) ? payload.publicNotebooks : []),
    ...(Array.isArray(payload?.subscribedPublicNotebooks) ? payload.subscribedPublicNotebooks : []),
  ];
  const publicByTitle = new Map(
    publicList
      .filter((nb) => nb?.title)
      .map((nb) => [nb.title.trim().toLowerCase(), nb]),
  );

  const fromApi = Array.isArray(payload?.catalogItems) ? payload.catalogItems : [];
  if (fromApi.length > 0) {
    return fromApi.map((raw) => normalizeRow(raw, publicByTitle)).filter(Boolean);
  }

  const topics = Array.isArray(payload?.catalog) ? payload.catalog : [];
  return topics
    .map((topic) => normalizeRow({ topic }, publicByTitle))
    .filter(Boolean);
}
